import { Fragment } from "react";
import Link from "components/layout/Link";
import Text from "components/typography/Text";
import LinkNative from "components/layout/LinkNative";
import generatePath from "utils/generatePath";
import styled from "styled-components";
import containers from "containers";
import reactStringReplace from "react-string-replace";

// TODO: REFACTOR BIG TIME!!.
// TODO: REFACTOR BIG TIME!!.
// TODO: REFACTOR BIG TIME!!.

const newlineRegex = /(\r\n|\r|\n)/g;

const MentionComponent = styled(({ id, type, name, ...rest }) => {
	switch (type) {
		case "user": {
			const to = generatePath(containers.user.path, {
				login: name?.toLowerCase(),
			});

			return (
				<Link noColorVisited underline to={to} {...rest}>
					@{name}
				</Link>
			);
		}
		default:
			return null;
	}
})`
	vertical-align: baseline;
	display: inline;
	color: ${({ theme: { colors } }) => colors.whiteAlways};
	font-weight: bold;
	box-shadow: ${({ selected, focused, theme: { colors } }) =>
		selected && focused ? `0 0 0 2px ${colors.whiteAlways}` : "none"};
`;

const globalConvertTextCalls = 0;
let globalConvertTextPieces = 0;
const generatePieceKey = (index) => {
	globalConvertTextPieces++;
	return `pc-${globalConvertTextCalls}-${globalConvertTextPieces}-${index}`;
};

const urlize = (text, key = "key") => {
	const newText = text.replace(/<denyUrl>|<\/denyUrl>/g, "");
	const replacedText = reactStringReplace(
		newText,
		/<allowUrl>(.*?)<\/allowUrl>/g,
		(match, i) => {
			return (
				<LinkNative
					style={{ wordBreak: "break-word" }}
					key={`${match}_${i}_${key}`}
					href={match}
					target="_blank"
					color="whiteAlways"
					underline
					noColorVisited
				>
					{match}
				</LinkNative>
			);
		}
	);

	return <span key={key}>{replacedText}</span>;
};

const urlizePieces = (text) =>
	text
		.replace(/<denyUrl>|<\/denyUrl>/g, "")
		.replace(/<allowUrl>|<\/allowUrl>/g, "");

const convertTextInModal = ({ pieces = [] }) => {
	if (typeof pieces === "string") {
		return <Text>{urlizePieces(pieces)}</Text>;
	}
	if (Array.isArray(pieces) === true) {
		return (
			<>
				{pieces.map((item, i) => {
					const key = generatePieceKey(i);
					if (typeof item === "object") {
						switch (item.type || item.action) {
							case "user":
								// eslint-disable-next-line no-case-declarations
								const mentionsStrings =
									item.name.match(/^@(.+)/);
								return (
									<MentionComponent
										type={item.type}
										id={item.id}
										name={
											mentionsStrings !== null
												? mentionsStrings[1]
												: item.name
										}
										key={key}
									/>
								);
							case "line": {
								if (!item.text.trim().length) {
									return <br />;
								}

								return (
									<Fragment key={key}>
										<Text>
											{urlize(item.text) ||
												JSON.stringify(item)}
										</Text>
										<br />
									</Fragment>
								);
							}

							case "text":
							default:
								return (
									<Text key={key}>
										{urlize(item.text) ||
											JSON.stringify(item)}
									</Text>
								);
						}
					} else if (typeof item === "string") {
						return (
							<Fragment key={key}>
								{item
									.split(newlineRegex)
									.map((line, index2) => {
										const subKey = `${key}-${index2}`;
										if (line.match(newlineRegex)) {
											return <br key={subKey} />;
										}

										return urlize(line, subKey);
									})}
							</Fragment>
						);
					}
					return <Text key={key}>{JSON.stringify(item)}</Text>;
				})}
			</>
		);
	}
	return pieces ? JSON.stringify(pieces) : null;
};

export default convertTextInModal;

export { urlizePieces };
